import React from 'react';
import { Button, Checkbox, FormControl, FormControlLabel, Grid, TextField, InputAdornment, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from 'react';
import { grey } from '@mui/material/colors';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AddShiftTimeConfigureAction, UpdateShiftTimeConfigureAction } from '../../../../../store/Leave/ShiftConfigure/Action';
import CommonTimePicker from '../../../Base/views/CommonTimePicker';

const ShitTimeConfigurePopup = ({ editedRecord, setOpenPopup }) => {
    const dispatch = useDispatch();
    const [shifttime, setShiftTime] = useState({
        shift_name: "",
        time_in: "",
        time_out: "",
        pay: "0",
        breakshift_flag: false,
        before_in_time: "",
        before_out_time: "",
        after_in_time: "",
        after_out_time: "",
        alias: "",
    });

    const [errors, setErrors] = useState({});
   

    useEffect(() => {
        if (editedRecord != null) {
            setShiftTime({
                ...editedRecord,
                time_in: editedRecord.in_time ? ConvertToDate(editedRecord.in_time) : "",
                time_out: editedRecord.out_time ? ConvertToDate(editedRecord.out_time) : "",
                before_in_time: editedRecord.before_in_time ? ConvertToDate(editedRecord.before_in_time) : "",
                before_out_time: editedRecord.before_out_time ? ConvertToDate(editedRecord.before_out_time) : "",
                after_in_time: editedRecord.after_in_time ? ConvertToDate(editedRecord.after_in_time) : "",
                after_out_time: editedRecord.after_out_time ? ConvertToDate(editedRecord.after_out_time) : "",
            });
        }
    }, [editedRecord])
    const ConvertToDate = (timeString) => {
        if (!timeString) return null;
        const [hours, minutes, seconds] = timeString.split(":");
        const date = new Date();
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));
        date.setSeconds(parseInt(seconds, 10));
        return date; // Returns a Date object
    };

    const getMinutes = (date) => {
        if (!date) return null;
        return date.getHours() * 60 + date.getMinutes();
    };
    const validate = (fieldValues) => {
        let temp = { ...errors };

        if ("shift_name" in fieldValues) {
            temp.shift_name = fieldValues.shift_name === "" ? "Shift name is required" : "";
        }
        if ("alias" in fieldValues) {
            temp.alias = fieldValues.alias === "" ? "Alias name is required" : (fieldValues.alias.length > 4 ? "Alias name cannot exceed 4 characters" : "");
        }
        if ("time_in" in fieldValues && !fieldValues?.breakshift_flag) {
            temp.time_in = fieldValues.time_in === "" ? "Timein is required" : "";
        }
        if ("time_out" in fieldValues && !fieldValues?.breakshift_flag) {
            temp.time_out = fieldValues.time_out === "" ? "Timeout is required" : "";
        }
        if ("pay" in fieldValues) {
            temp.pay = fieldValues.pay === "" ? "pay is required" : "";
        }
        if (fieldValues?.breakshift_flag) {
            const bbIn = getMinutes(fieldValues?.before_in_time);
            const bbOut = getMinutes(fieldValues?.before_out_time);
            const abIn = getMinutes(fieldValues?.after_in_time);
            const abOut = getMinutes(fieldValues?.after_out_time);

            // Required checks
            temp.before_in_time = fieldValues?.before_in_time ? "" : "Required";
            temp.before_out_time = fieldValues?.before_out_time ? "" : "Required";
            temp.after_in_time = fieldValues?.after_in_time ? "" : "Required";
            temp.after_out_time = fieldValues?.after_out_time ? "" : "Required";

            // Logical checks - Before Break
            if (bbIn && bbOut) {
                temp.before_out_time = bbIn >= bbOut 
                    ? "Before Break OUT must be after IN"
                    : "";
            }

            // Logical checks - After Break
            if (abIn && abOut) {
                temp.after_out_time = abIn >= abOut 
                    ? "After Break OUT must be after IN"
                    : "";
            }

            // MAIN RULE: No overlap
            if (bbOut && abIn) {
                temp.after_in_time = bbOut >= abIn
                    ? "After Break must start after Before Break ends"
                    : "";
            }
        }
        setErrors({
            ...temp,
        });

        return Object.values(temp).every((x) => x === "");
    };

    const handleInputChange = (event, value) => {
        if (['time_in', 'time_out', "before_in_time", "before_out_time", "after_in_time", "after_out_time"].includes(event)) {
            setShiftTime({ ...shifttime, [event]: value });
            Object.values?.(errors)?.some((res) => res !== "") &&
                validate({ ...shifttime, [event]: value });
        } else if (event === "breakshift_flag") {
            setShiftTime({ 
                ...shifttime, 
                breakshift_flag: value,
                before_in_time: "",
                before_out_time: "",
                after_in_time: "",
                after_out_time: ""
             });
                Object.values?.(errors)?.find((res) => res !== "")?.length > 0 && 
                setErrors(prevErrors => ({
                    ...prevErrors,
                        before_in_time: "",
                        before_out_time: "",
                        after_in_time: "",
                        after_out_time: "",
                        time_in: "",
                        time_out: "",
                }));
        }
        else {
            setShiftTime({ ...shifttime, [event.target.name]: event.target.value });
            Object.values?.(errors)?.find(res => res !== "")?.length > 0 &&
                validate({ ...shifttime, [event.target.name]: event.target.value })
        }

    }

    const handleSubmit = (event) => {
            if (validate(shifttime)) {
                const formatTime = (time) => {
                    if (!time) return "";
                    const date = new Date(time);
                    return date.toLocaleTimeString("en-GB", { hour12: false });
                };
                const formattedShiftTime = {
                    ...shifttime,
                    time_in: formatTime(shifttime.time_in),
                    time_out: formatTime(shifttime.time_out),
                    before_in_time: formatTime(shifttime.before_in_time),
                    before_out_time: formatTime(shifttime.before_out_time),
                    after_in_time: formatTime(shifttime.after_in_time),
                    after_out_time: formatTime(shifttime.after_out_time),
                };
                if (shifttime?.shift_roster_configuration_id)
                    dispatch(UpdateShiftTimeConfigureAction(formattedShiftTime));
                else
                    dispatch(AddShiftTimeConfigureAction(formattedShiftTime));

                setOpenPopup(false);
            }
    };

    return (
        <>
            <>
                <Grid container>
                    <Grid container>
                        <Grid key="shift_name" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                            <FormControl fullWidth >
                                <TextField
                                    size="small"
                                    required
                                    value={shifttime?.shift_name}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    fullWidth
                                    id="shift_name"
                                    label="Shift Name"
                                    name="shift_name"
                                    {...(errors.shift_name && {
                                        error: true,
                                        helperText: errors.shift_name,
                                    })}
                                />
                            </FormControl>
                        </Grid>
                        <Grid key="alias" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                            <FormControl fullWidth>
                                <TextField
                                    size="small"
                                    required
                                    value={shifttime?.alias || ""}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    fullWidth
                                    id="alias"
                                    label="Shift Code"
                                    name="alias"
                                    inputProps={{ maxLength: 4 }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="This shift code will be used in the shift consolidate view, where a shorter shift label is shown instead of the full shift name.">
                                                    <IconButton edge="end">
                                                        <InfoOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                    {...(errors.alias && {
                                        error: true,
                                        helperText: errors.alias,
                                    })}
                                />
                            </FormControl>
                        </Grid>
                        <Grid key="breakshift_flag" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={shifttime?.breakshift_flag}
                                        disabled={editedRecord ? true : false}
                                        onChange={(e) => handleInputChange("breakshift_flag", e.target.checked)}
                                    />
                                }
                                label="Break Shift"
                            />
                        </Grid>
                       {shifttime?.breakshift_flag ? (
                        <>                  
                            <Grid item xs={12} sx={{ marginTop: "1rem", paddingLeft: "15px" }}>
                                <strong>Before Break</strong>
                            </Grid>

                            <Grid item xs={12} md={6} sx={{ marginTop: "0.5rem", padding: "0 15px" }}>
                                <FormControl fullWidth>
                                    <CommonTimePicker
                                        size="small"
                                        required
                                        name="before_in_time"
                                        label="Time In"
                                        DefaultDTvalue={shifttime?.before_in_time}
                                        handleChange={(value) => handleInputChange("before_in_time", value)}
                                        {...(errors.before_in_time && {
                                            error: true,
                                            helperText: errors.before_in_time,
                                        })}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6} sx={{ marginTop: "0.5rem", padding: "0 15px" }}>
                                <FormControl fullWidth>
                                    <CommonTimePicker
                                        size="small"
                                        required
                                        name="before_out_time"
                                        label="Time Out"
                                        DefaultDTvalue={shifttime?.before_out_time}
                                        handleChange={(value) => handleInputChange("before_out_time", value)}
                                        {...(errors.before_out_time && {
                                            error: true,
                                            helperText: errors.before_out_time,
                                        })}
                                    />
                                </FormControl>
                            </Grid>

                            {/* AFTER BREAK */}
                            <Grid item xs={12} sx={{ marginTop: "1rem", paddingLeft: "15px" }}>
                                <strong>After Break</strong>
                            </Grid>

                            <Grid item xs={12} md={6} sx={{ marginTop: "0.5rem", padding: "0 15px" }}>
                                <FormControl fullWidth>
                                    <CommonTimePicker
                                        size="small"
                                        required
                                        name="after_in_time"
                                        label="Time In"
                                        DefaultDTvalue={shifttime?.after_in_time}
                                        handleChange={(value) => handleInputChange("after_in_time", value)}
                                        {...(errors.after_in_time && {
                                            error: true,
                                            helperText: errors.after_in_time,
                                        })}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6} sx={{ marginTop: "0.5rem", padding: "0 15px" }}>
                                <FormControl fullWidth>
                                    <CommonTimePicker
                                        size="small"
                                        required
                                        name="after_out_time"
                                        label="Time Out"
                                        DefaultDTvalue={shifttime?.after_out_time}
                                        handleChange={(value) => handleInputChange("after_out_time", value)}
                                        {...(errors.after_out_time && {
                                            error: true,
                                            helperText: errors.after_out_time,
                                        })}
                                    />
                                </FormControl>
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid key="time_in" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                                <FormControl fullWidth >
                                    <CommonTimePicker
                                        size="small"
                                        required
                                        name="time_in"
                                        label="Time In"
                                        onKeyDown={(e) => e.preventDefault()}
                                        onKeyPress={(e) => e.preventDefault()}
                                        DefaultDTvalue={shifttime?.time_in}
                                        handleChange={(value) => handleInputChange("time_in", value)}
                                        {...(errors.time_in && {
                                            error: true,
                                            helperText: errors.time_in,
                                        })}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid key="time_out" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                                <FormControl fullWidth >
                                    <CommonTimePicker
                                        size="small"
                                        required
                                        name="time_out"
                                        label="Time Out"
                                        onKeyDown={(e) => e.preventDefault()}
                                        onKeyPress={(e) => e.preventDefault()}
                                        DefaultDTvalue={shifttime?.time_out}
                                        handleChange={(value) => handleInputChange("time_out", value)}
                                        {...(errors.time_out && {
                                            error: true,
                                            helperText: errors.time_out,
                                        })}
                                    />
                                </FormControl>
                            </Grid>
                        </>
                    )}
                        <Grid key="pay" item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                            <FormControl fullWidth >
                                <TextField
                                    required
                                    size="small"
                                    value={shifttime?.pay}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    fullWidth
                                    id="pay"
                                    label="Pay"
                                    name="pay"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Additional pay per hour for employees assigned to this shift.">
                                                    <IconButton edge="end">
                                                        <InfoOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                    {...(errors.pay && {
                                        error: true,
                                        helperText: errors.pay,
                                    })}
                                />
                            </FormControl>
                        </Grid>

                    </Grid>
                    <Grid container sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}>
                        <Button
                            sx={{ marginTop: "1rem", marginRight: "1rem", ":hover": { color: grey[50] } }}
                            variant="outlined"
                            onClick={() => setOpenPopup(false)}
                            className="mpl-secondary-btn"
                        >
                            cancel
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSubmit} className="mpl-primary-btn" sx={{ marginTop: "1rem", marginRight: "1rem" }}>
                            {editedRecord ? "Update" : "Save"}
                        </Button>
                    </Grid>
                </Grid>
            </>
        </>
    );
}

export default ShitTimeConfigurePopup;
